import { render } from "./About.vue?vue&type=template&id=35cf7f57"
const script = {}

import "./About.vue?vue&type=style&index=0&id=35cf7f57&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__